module.exports = __webpack_public_path__ + "static/media/MOVIDA.018d287c.png";